import { Colors, colors } from '@microfrontends/react-components'
import styled from 'styled-components'

export const StyledFilterBar = styled.div`
    .filter-footer {
        position: sticky;
        bottom: 0;
        z-index: 5;
        width: 100%;
        padding: 16px;
        box-shadow: 0 -1px 3px 0 rgba(0, 0, 0, 0.15);
        background: white;
        .btn {
            color: white;
            background: #ff7d55;
            border-color: #ff7d55;
            font-size: 1.1rem;
        }
    }

    .multi-category {
        .select-container {
            -webkit-flex-wrap: inherit !important;
            -ms-flex-wrap: inherit !important;
            flex-wrap: inherit !important;
            -webkit-flex-wrap: inherit !important;
            > span {
                padding-left: 0 !important;
            }
            .multiple-select-selected-values {
                padding-top: 5px !important;
                padding-left: 0 !important;
                padding-right: 14px;
            }
            .select-dropdown {
                max-width: 320px !important;
                top: 40px !important;
            }
        }
    }

    .desktop {
        display: flex;
        gap: 8px;
        flex-direction: column;
        border-radius: 12px;
        padding: 12px;
        background-color: #fff;
        box-shadow: 0 1px 8px rgba(0, 0, 0, 0.12);
    }

    .desktop-filter-bar {
        padding: 6px !important;
    }

    .desktopFilter {
        display: flex;
        flex-direction: row;
    }

    .mobile {
        display: none;
    }

    .action {
        display: inline-flex;
        align-items: center;
        transition: 0.25s;

        .icon {
            margin-left: 8px;
            display: inline-flex;
        }

        &:only-child {
            margin-right: 0;
        }
    }

    .tree-select {
        [data-id='tree-select'] {
            > div > div > div {
                color: #333;
                font-size: 14px;
            }
        }
    }

    .action-link {
        color: #005aff;
        cursor: pointer;
    }

    .action-btn {
        margin: 0 8px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .check-box-label {
        font-size: 13px;
    }

    .left-bar {
        display: flex;
        align-items: center;
        flex-basis: auto;
        transition: all 0.3s;
        gap: 8px;

        svg {
            vertical-align: baseline;
        }
    }

    .right-bar {
        font-size: 13px;
        margin-left: auto;
        &:focus {
            outline: none;
            .action,
            .filter-badge {
                outline: none;
            }
        }
        .action {
            &:hover,
            &:focus {
                color: #ff7d55;
                .filter-badge {
                    background: #ff7d55;
                    color: #fff;
                }
            }
        }
        .quick-create-job-alert {
            display: flex;
            align-items: center;
            align-content: center;
            > span {
                margin-right: 8px;
                font-size: 14px;
            }
            > div {
                > label {
                    display: none;
                }
            }
        }
    }

    .dropdown-action {
        position: relative;
        flex-basis: auto;
    }

    .dropdown-container {
        background: white;
        z-index: 5;
        border-radius: 6px;
        box-shadow: 0px 2px 4px ${Colors.cardShadow};
        border: 1px solid #e8e8e8;
        padding: 16px;
        width: 420px;

        /* .arrow-up {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: -8px;
            z-index: 5;
            width: 0;
            height: 0;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-bottom: 8px solid #e8e8e8;

            &:after {
                content: '';
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                top: 1.5px;
                z-index: 5;
                width: 0;
                height: 0;
                border-left: 6.5px solid transparent;
                border-right: 6.5px solid transparent;
                border-bottom: 6.5px solid white;
            }
        } */
    }

    .dropdown-row {
        display: flex;
        flex-direction: column;
        margin-bottom: 15px;

        > div {
            flex: 1 1 0;
        }
    }

    .dropdown-heading {
        margin-bottom: 15px;
        text-transform: uppercase;
        font-weight: 600;
        font-size: 1.125rem;
    }

    .filter-badge {
        background: #005aff;
        color: white;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin-left: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: 0.25s;
    }

    .custom-drop-down {
        [id='multiple-radio'] > div:first-child,
        [data-id='tree-select'] > div:first-child,
        > div > div > div:first-child {
            border: 1px solid ${colors.neutral[90]};
        }
    }

    @media screen and (max-width: 991px) {
        .desktop {
            display: none;
        }

        .mobile {
            display: flex;
            padding: 12px 0;
            align-items: center;
            background: white;
            > div {
                display: flex;
                align-items: center;
                justify-content: center;
                flex: 1;

                svg {
                    width: 20px;
                    height: 20px;
                }

                > .filter-filled {
                    position: relative;
                    display: inline-flex;

                    > .filter-number {
                        position: absolute;
                        right: -6px;
                        top: -2px;
                        width: 60%;
                        height: 60%;
                        font-size: 0.6rem;
                        display: inline-flex;
                        border-radius: 50%;
                        border: 1px solid white;
                        background: #f85a5a;
                        align-items: center;
                        justify-content: center;
                        color: white;
                    }

                    ~ .label {
                        margin-left: 15px;
                    }
                }

                .label {
                    margin-left: 10px;
                    text-transform: uppercase;
                    font-weight: normal;
                }
            }
        }
    }
`

export const StyledModalFilter = styled.div`
    .filter-item-container {
        background: #fff;
        padding: 16px;
        margin-top: 8px;
        border: 1px solid #ececec;
    }
`

export const StyledClearFilterLink = styled.button`
    padding: 0;
    display: block;
    margin-left: auto;
    font-size: 12px;
    line-height: 15px;
    text-transform: uppercase;
    max-width: 62px;
`

export const FilterWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    border-radius: 6px;
    transition: 0.25s;

    :hover {
        background-color: ${Colors.tagSelectBorder};
    }
    [data-check-state] > label > span {
        max-width: initial;
    }
`

export const MoreTitle = styled.p`
    color: ${Colors.text};
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 8px;
`

export const MoreFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 16px;
`

export const MoreFooterRight = styled.div``

export const ClearAllText = styled.div`
    font-size: 14px;
    line-height: 18px;
    color: ${Colors.primary};
    padding: 8px 0;
    cursor: pointer;
`

export const SelectedBenefit = styled.span`
    font-size: 12px;
    margin: 0 5px 0 10px;
    color: ${Colors.text + '99'};
    line-height: 1;
`

export const Clear = styled.span`
    color: ${Colors.primary};
    font-size: 14px;
    cursor: pointer;
`

export const BottomSheetFooter = styled.div`
    display: flex;
    gap: 8px;
    margin: 16px 0;

    > button {
        flex: 1;
    }
`
